import { PayoutMethodEnum } from "enum/common";

export const PHONE_VALIDATION_REGEX =
  /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{4,6}$/im;
export const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const getAuthToken = () => localStorage.getItem("AUTH_TOKEN");
export const getRefreshToken = () => localStorage.getItem("REFRESH_TOKEN");
export const getSocketID = () => localStorage.getItem("SOCKET_ID");

export const checkInputFormat = (input: string) => {
  if (PHONE_VALIDATION_REGEX.test(input)) {
    return "phone";
  }
  if (EMAIL_VALIDATION_REGEX.test(input)) {
    return "email";
  }
};

export const checkIsAnywhereCommunity = (business?: BusinessType) => {
  if (!business) return false;
  const anyWhereCommunitiesList = business?.communities?.filter(
    (community: CommunityType) => community?.isGlobal
  );
  return (
    !!anyWhereCommunitiesList?.length ||
    business?.onboardingCommunityDetails?.isGlobal
  );
};

export const isFutureDate = (date: string) => {
  const moment = require("moment"); // Make sure to import moment

  const dateString = date; // Your date string
  const targetDate = moment(dateString); // Parse the date string

  return targetDate.isAfter(moment()); // Compare with the current date
};

export const getBaseUrl = () => {
  return process.env.REACT_APP_APPLICATION_ENV === "DEV"
    ? "https://d3pqdp9dade80h.cloudfront.net"
    : process.env.REACT_APP_APPLICATION_ENV === "STAGING"
    ? "https://onboarding-portal-staging.bludot.io"
    : process.env.REACT_APP_APPLICATION_ENV === "PROD"
    ? "https://business.openrewards.com"
    : "http://localhost:3000";
};

export const fileDownload = async (
  url: string,
  filename: string = "download.jpg"
) => {
  window.open(url, "_blank");
};

export const getFormattedPayoutname = (type: PayoutMethodEnum) => {
  switch (type) {
    case PayoutMethodEnum.PAYPAL:
      return "Paypal";
    case PayoutMethodEnum.VENMO:
      return "Venmo";
    case PayoutMethodEnum.ZELLE:
      return "Zelle";
    case PayoutMethodEnum.CHECK:
      return "Check";
    case PayoutMethodEnum.CANADA_EFT:
      return "Canada EFT";
    default:
      return "Payout Method";
  }
};

// Referral Code Management
const REFERRAL_CODE_KEY = "referralCode";

/**
 * Extracts referral code from URL parameters and stores it in session storage
 */
export const extractAndStoreReferralCode = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get(REFERRAL_CODE_KEY);

    if (referralCode?.trim()) {
      sessionStorage.setItem(REFERRAL_CODE_KEY, referralCode.trim());
      return referralCode.trim();
    }
    
    return null;
  } catch (error) {
    console.error("Error extracting referral code from URL:", error);
    return null;
  }
};

/**
 * Gets the stored referral code from session storage
 */
export const getStoredReferralCode = (): string => {
  try {
    return sessionStorage.getItem(REFERRAL_CODE_KEY) || "";
  } catch (error) {
    console.error("Error getting stored referral code:", error);
    return "";
  }
};

/**
 * Clears the stored referral code from session storage
 * Should be called after successfully using the referral code
 */
export const clearStoredReferralCode = (): void => {
  try {
    sessionStorage.removeItem(REFERRAL_CODE_KEY);
  } catch (error) {
    console.error("Error clearing stored referral code:", error);
  }
};

/**
 * Stores referral code in session storage
 */
export const setReferralCode = (code: string) => {
  try {
    if (code && code.trim()) {
      sessionStorage.setItem(REFERRAL_CODE_KEY, code.trim());
    }
  } catch (error) {
    console.error("Error storing referral code:", error);
  }
};

/**
 * Clears the stored referral code from session storage
 */
export const clearReferralCode = () => {
  try {
    sessionStorage.removeItem(REFERRAL_CODE_KEY);
  } catch (error) {
    console.error("Error clearing referral code:", error);
  }
};
